/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/map-zoom-minus': {
    width: 40,
    height: 40,
    viewBox: '0 0 40 40',
    data: '<circle pid="0" cx="20" cy="20" r="19" _fill="#F2FAFE" _stroke="#447077" stroke-width="2"/><path pid="1" _stroke="#447077" stroke-width="2" stroke-linecap="round" d="M28 20H11"/>'
  }
})
